import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import {Col, Input, Row, Label, Form, Button, Progress} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import Select from "react-select"
import { withTranslation } from "react-i18next"
const AddDemandeAdministrativeEnseignant = props => {
  const [name, setName] = useState("");
  const [file, setFile] = useState(null)
  const [uploadPercent, setUploadPercent] = useState(0)
  const [disbutReg, setDisbutReg] = useState(true)

  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const save = async () => {
    var pathFile = ""
    if (file != null) {
      pathFile = file.name
    }
    if(name == ""){
      setDisbutReg(true)
      toast.error("⛔  Nom obligatoire !", {
        containerId: "A",
      })
    }else if(pathFile == ""){
      setDisbutReg(true)
      toast.error("⛔  Fichier obligatoire !", {
        containerId: "A",
      })
    }else{
      setDisbutReg(false)
      const res = await API.post("document/enseignant/vierge/add", {
        name: name,
        file: pathFile,
      }).then(res => {
        if (res.data.status == 200) {
          let data = new FormData()
          data.append("file", file)
          const options = {
            onUploadProgress: progressEvent => {
              const { loaded, total } = progressEvent
              let percent = Math.round((loaded * 100) / total)
              console.log(`${loaded}kb of ${total}kb | ${percent}%`)
              if (percent < 100) {
                setUploadPercent(percent)
              }
            },
          }
          API.post("document/enseignant/vierge/upload", data, options).then(res => {
            if (res.data.status == 200) {
              setUploadPercent(100)
              props.setSection(3)
            } else {
              setDisbutReg(true)
              toast.error(
                  "⛔ Problème lors de l'insertion !",
                  {
                    containerId: "A",
                  }
              )
            }
          })
        }
      }).catch(() => {
        setDisbutReg(true)
            toast.error("⛔  Problème lors de l'insertion !", {
              containerId: "A",
            })
          })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Nom")}
                </Label>
                <Input
                  lg="3"
                  type="text"
                  className="form-control"
                  placeholder={props.t("Nom")}
                  onChange={e => setName(e.target.value)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Fichier :</Label>
                <Input
                    onChange={e => addFile(e)}
                    className="form-control"
                    type="file"
                    id="formFile"
                    accept=".pdf"
                />
              </div>
            </Col>
          </Row>
          <Row>
            {uploadPercent > 0 && uploadPercent < 100 ? (
                <Progress
                    striped
                    className="progress-xl"
                    color="success"
                    value={uploadPercent}
                >
                  {uploadPercent}%
                </Progress>
            ) : null}
          </Row>
        </Form>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {" "}
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              className="text-center mt-4"
            >
              <Button
                type="button"
                color="warning"
                className="btn btn-warning  mb-2 me-2"
                onClick={props.back}
              >
                {props.t("Annuler")}
              </Button>
            </div>
          </Col>
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              className="text-center mt-4"
            >
              <button type="button" className="btn btn-primary " disabled={!disbutReg}  onClick={save}>
                {props.t("Confirmer")}
              </button>
            </div>
          </Col>
        </div>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddDemandeAdministrativeEnseignant)
AddDemandeAdministrativeEnseignant.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
